import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../CookieAuth/auth.service';
import { ConfHttpService } from './conf-http.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  endpopint:string='';
  
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService) {
    this.headers= new HttpHeaders({'Content-Type': 'application/json'});
    this.endpopint=conf.getBackend();
  }

  get(){
    return this.http.get<any[]>(this.endpopint+'app');
  }

}
